import { lazy, Suspense, useEffect, useState } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
// import { setAuthUser } from "./features/Auth Slice/authSlice";
import { useDispatch, useSelector } from "react-redux";
import "simplebar-react/dist/simplebar.min.css";
import LoaderSpinner from "./Components/Loader/Loader";
import LogIn from "./Components/Login";
import Toast from "./Components/Toast/Toast";
import CreateProfile from "./Components/create-profile";
import EmailSent from "./Components/email-sent";
import NewPassword from "./Components/new-password";
import Forgot from "./Pages/Forgot";
import { setAuthUser } from "./features/Auth Slice/authSlice";
import { RootState } from "./store/store";
import spinnerSvc from "./utils/spinner-service";

// Lazy load role bundles — each role is a separate chunk
const Branch_Admin_Routes = lazy(() => import("./Pages/branch-admin/Branch_Admin_Routes"));
const Nurse_Manager_Routes = lazy(() => import("./Pages/nurse-manager/Nurse_Manager_Routes"));
const Super_Admin_Routes = lazy(() => import("./Pages/super-admin/Super_Admin_Routes"));
const Operation_Manager_Routes = lazy(() => import("./Pages/operation-manager/Operation_Manager_Routes"));

const App = () => {
  const [loading, setLoading] = useState(null);

  const dispatch: any = useDispatch();
  const data = useSelector((state: RootState) => state.auth.User);
  const { snackbar, toastMessage } = useSelector(
    (state: RootState) => state.toast
  );
  useEffect(() => {
    const subscription = spinnerSvc.requestInProgress.subscribe((data) => {
      setLoading(data);
    });
    return () => {
      subscription.unsubscribe();
    };
  }, []);
  // const { User } = useSelector((state: RootState) => state.auth);
  // const socket = io("https://dev.api.healthcare.aquila360.com");

  // const socket = io("https://dev.api.healthcare.aquila360.com", {
  //   transports: ["websocket"], // Specify the WebSocket transport
  //   secure: true, // Enable secure connection (wss)
  // });

  const user = JSON.parse(sessionStorage.getItem("user")!);
  useEffect(() => {
    if (user) dispatch(setAuthUser(user));
  }, []);

  // ── Handle SSO redirect: pick up tokens Azure dropped in the URL ──────
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ssoAccessToken = params.get("sso_access_token");
    const ssoRefreshToken = params.get("sso_refresh_token");
    const ssoError = params.get("sso_error");

    if (ssoError) {
      console.error("[SSO] Error from Azure:", ssoError);
      // Clean URL so refresh doesn't re-trigger
      window.history.replaceState({}, document.title, "/");
      return;
    }

    if (ssoAccessToken && ssoRefreshToken) {
      try {
        const jwtDecode = require("jwt-decode").default;
        const tokenData: any = jwtDecode(ssoAccessToken);
        sessionStorage.setItem("user", JSON.stringify(tokenData));
        sessionStorage.setItem("acToken", ssoAccessToken);
        sessionStorage.setItem("rtToken", ssoRefreshToken);
        dispatch(setAuthUser(tokenData));
        // Clean the tokens out of the URL
        window.history.replaceState({}, document.title, "/");
      } catch (e) {
        console.error("[SSO] Failed to decode token:", e);
        window.history.replaceState({}, document.title, "/");
      }
    }
  }, []);
  // useEffect(() => {
  //   if (!User?.id) return;
  //   console.log("check user: ", User);
  //   // Join the Nurse Director's room using their unique ID
  //   // socket.emit("joinRoom", User?.id);
  //   socket.emit("send_message", { message: "Hello" });
  //   // Listen for the 'scheduleSubmitted' event in the Nurse Director's room
  //   // socket.on("", (data) => {
  //   //   // Handle the received data (schedule submission notification)
  //   //   console.log("Received schedule submission:", data);
  //   // });

  //   // Cleanup the event listener when the component unmounts
  //   // return () => {
  //   //   socket.off("scheduleSubmitted");
  //   // };
  // }, [User]);
  return (
    <>
      {loading && <LoaderSpinner />}
      <Toast
        snackbar={snackbar}
        toastMessage={toastMessage}
        // setSnackbar={setSnackbar}
        // setToastMessage={setToastMessage}
      />
      {data?.role === "branch admin" ? (
        <Suspense fallback={<LoaderSpinner />}>
          <Branch_Admin_Routes />
        </Suspense>
      ) : data?.role === "operation manager" ? (
        <Suspense fallback={<LoaderSpinner />}>
          <Operation_Manager_Routes />
        </Suspense>
      ) : data?.role === "super admin" ? (
        <Suspense fallback={<LoaderSpinner />}>
          <Super_Admin_Routes />
        </Suspense>
      ) : data?.role === "nurse manager" ||
        data?.role === "nurse director" ||
        data?.temporaryRole === "nurse manager" ? (
        <Suspense fallback={<LoaderSpinner />}>
          <Nurse_Manager_Routes />
        </Suspense>
      ) : (
        <Router>
          <Routes>
            <Route path="/" element={<LogIn />} />
            <Route path="/forgot-password" element={<Forgot />} />
            <Route path="/email-sent" element={<EmailSent />} />
            <Route path="/new-password" element={<NewPassword />} />
            <Route path="/create-profile" element={<CreateProfile />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      )}
    </>
  );
};

export default App;
